module.exports = __webpack_public_path__ + "static/img/anquanjiaoyu.398f3811.jpg";